var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlock = function SvgBlock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 16.667c0-1.841 1.492-3.333 3.333-3.333h16c1.841 0 3.333 1.492 3.333 3.333v10.667c0 1.841-1.492 3.333-3.333 3.333h-16c-1.841 0-3.333-1.492-3.333-3.333v-10.667zM8 16c-0.368 0-0.667 0.298-0.667 0.667v10.667c0 0.368 0.298 0.667 0.667 0.667h16c0.368 0 0.667-0.298 0.667-0.667v-10.667c0-0.368-0.298-0.667-0.667-0.667h-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c-2.946 0-5.333 2.388-5.333 5.333v5.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333v-5.333c0-4.418 3.581-8 8-8 4.418 0 8 3.578 8 8v5.333c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333v-5.333c0-2.948-2.387-5.333-5.333-5.333z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/block.8fa2a4fa.svg";
export { ForwardRef as ReactComponent };